import React from 'react';
import Calculator from './components/calculator/Calculator';

import './App.css';

function App() {
  return (
    <div>
     <Calculator />
     
    </div>
  );
}

export default App;
